import { render, staticRenderFns } from "./faultList.vue?vue&type=template&id=db21143e&scoped=true"
import script from "./faultList.vue?vue&type=script&lang=js"
export * from "./faultList.vue?vue&type=script&lang=js"
import style0 from "./faultList.vue?vue&type=style&index=0&id=db21143e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db21143e",
  null
  
)

export default component.exports